import React from "react";
import { MetricListPanel, Panel, SectionGrid, SummaryGrid } from "../AdminAnalyticsCards";
import CssBarChart from "../charts/CssBarChart";
import AdminAnalyticsTable, { UserCell } from "../tables/AdminAnalyticsTable";
import { aa, formatDay, formatLabel, formatNumber, getUserLabel, getUserSubLabel } from "../adminAnalyticsUtils";
export default function AdminAnalyticsContentTab({
  data
}) {
  const summary = data?.summary || {};
  const groupSummary = data?.groupContentSummary || {};
  return <>
      <SummaryGrid cards={[{
      label: aa("total_posts", "Total posts"),
      value: formatNumber(summary.totalPosts)
    }, {
      label: aa("new_posts", "New posts"),
      value: formatNumber(summary.newPosts)
    }, {
      label: aa("users_who_posted", "Users who posted"),
      value: formatNumber(summary.usersWhoPosted)
    }, {
      label: aa("posts_with_media", "Posts with media"),
      value: formatNumber(summary.postsWithMedia)
    }, {
      label: aa("media_records", "Media records"),
      value: formatNumber(summary.totalMediaRecords)
    }, {
      label: aa("images", "Images"),
      value: formatNumber(summary.imageCount)
    }, {
      label: aa("videos", "Videos"),
      value: formatNumber(summary.videoCount)
    }, {
      label: aa("group_posts", "Group posts"),
      value: formatNumber(summary.groupPosts)
    }]} />


      <SectionGrid>
        <CssBarChart title={aa("posts_by_day", "Posts by day")} rows={data?.postsByDay} getLabel={row => formatDay(row?.day)} getValue={row => row?.posts} />

        <CssBarChart title={aa("posts_by_type", "Posts by type")} rows={data?.postsByType} getLabel={row => formatLabel(row?.postType)} getValue={row => row?.posts} />

        <CssBarChart title={aa("media_by_kind", "Media by kind")} rows={data?.mediaByKind} getLabel={row => formatLabel(row?.mediaKind)} getValue={row => row?.count} />

        <CssBarChart title={aa("media_by_category", "Media by category")} rows={data?.mediaByCategory} getLabel={row => formatLabel(row?.mediaCategory)} getValue={row => row?.count} />

        <Panel title={aa("group_content_summary", "Group content summary")}>
          <div className="admin-analytics-completion-grid">
            {[[aa("group_posts", "Group posts"), groupSummary.groupPosts], [aa("group_post_media", "Group post media"), groupSummary.groupPostMedia], [aa("approved", "Approved"), groupSummary.approved], [aa("pending", "Pending"), groupSummary.pending]].map(([label, value]) => <div className="admin-analytics-completion-item" key={label}>
                <span>{label}</span>
                <strong>{formatNumber(value)}</strong>
              </div>)}
          </div>
        </Panel>
        <MetricListPanel title={aa("content_mix", "Content mix")} rows={[{
        label: aa("posts_with_media", "Posts with media"),
        value: summary.postsWithMedia
      }, {
        label: aa("images", "Images"),
        value: summary.imageCount
      }, {
        label: aa("videos", "Videos"),
        value: summary.videoCount
      }, {
        label: aa("group_posts", "Group posts"),
        value: summary.groupPosts
      }]} />

        <AdminAnalyticsTable title={aa("top_creators", "Top creators")} rows={data?.topCreators} rowKey={row => getUserSubLabel(row)} columns={[{
        header: aa("user", "User"),
        render: row => <UserCell title={getUserLabel(row)} subtitle={getUserSubLabel(row)} />
      }, {
        header: aa("posts", "Posts"),
        render: row => formatNumber(row?.postCount)
      }, {
        header: aa("media", "Media"),
        render: row => formatNumber(row?.mediaCount)
      }]} />

      </SectionGrid>
    </>;
}
